import { isEmpty } from 'lodash'

export const getFullLengthVidForPlayer = (video) => {
  if (!isEmpty(video?.videoAssets?.mp4)) {
    // migrated to adaptive bitrate
    // browser native <video/> component cannot play .m3u8 files, so use 1080p with fallback to 720p
    return video?.videoAssets?.mp4?.['1080p'] || video?.videoAssets?.mp4?.['720p']
  } else {
    // legacy
    return video?.video
  }
}
